module.exports = __webpack_public_path__ + "static/media/ssa.a437b8f6.svg";